import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import {
  NoItemsAdded,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/NoItemsAdded';
import {
  OwnerFiltersPicker,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/OwnerFiltersPicker';
import {
  InstitutionGroups,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/InstitutionGroups';
import OnboardingAddItemButton
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/ExpensesDetail/OnboardingAddItemButton';
import CollectionQueryForm from 'Components/ComponentLibrary/Molecules/CollectionQueryForm';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import {
  OwnAndOweChecklist,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/OwnAndOweChecklist';
import useBodyScrollLock from 'Hooks/useBodyScrollLock';

const OnboardingAssetsAndLiabilitiesAddContent = ({ resource }) => {
  const { loadModalCollectionByLink, modalCollection } = useModalContext();
  const { setOnboardingStepCollection, onboardingStepCollection, refreshOnboardingStepCollection } = useSurveyContext();
  useBodyScrollLock(modalCollection, true);
  return (
    <FDStack direction={'column'} spacing={5}>
      <FDStack direction={'row'} spacing={1} paddingX={2} justifyContent={'space-between'}>
        {resource.withRelationship(fr.relationships.addItem.name,
          (rel) => (
            <OnboardingAddItemButton relationship={rel} onAdd={() => loadModalCollectionByLink(rel.link('related').url())} />
          ),
          () => null)}
        <CollectionQueryForm
          formPadding={'none'}
          collection={onboardingStepCollection}
          layout={OwnerFiltersPicker}
          onSubmit={(resultCollection) => {
            setOnboardingStepCollection(resultCollection);
          }}
        />
      </FDStack>
      <OwnAndOweChecklist resource={resource} />
      {resource.withRelationship(fr.relationships.noItems.name,
        (rel) => (
          <NoItemsAdded
            title={rel.meta('title')}
            subtitle={rel.meta('subtitle')}
            icon={rel.meta('icon')}
            firstItemRel={resource.relationship(fr.relationships.addFirstItem.name)}
          />
        ),
        () => (<InstitutionGroups groupCollection={resource.attr('institutionGroups')} onRefresh={refreshOnboardingStepCollection} />))}
    </FDStack>
  );
};

OnboardingAssetsAndLiabilitiesAddContent.defaultProps = {};

OnboardingAssetsAndLiabilitiesAddContent.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { OnboardingAssetsAndLiabilitiesAddContent };
